export const CheckIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41421 4.24268L5.65685 8.48532L4.24264 9.89953L0 5.65689L1.41421 4.24268Z"
      fill="currentColor"
    />
    <path
      d="M11.3136 0L12.7278 1.41421L4.24264 9.89953L2.82835 8.48528L11.3136 0Z"
      fill="currentColor"
    />
  </svg>
);
